import './styles';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {ViewModelProvider} from './ViewModelContext';

const KycManuallyInReviewContent = () => {
  const {t} = useTranslation();

  return (
    <Box className="kyc-manually-review-container">
      <Box>
        <img
          src="/assets/images/etc/pending.svg"
          alt="time"
          style={{
            width: '120px',
            height: '120px',
          }}
        />
      </Box>
      <Box className="kyc-manually-review-text-container">
        <Typography className="kyc-manually-review-title">
          {t('kyc.manually_review.title')}
        </Typography>
        <Typography className="kyc-manually-review-description">
          {t('kyc.manually_review.description')}
        </Typography>
      </Box>
    </Box>
  );
};

const KycManuallyInReviewPage = () => (
  <ViewModelProvider>
    <KycManuallyInReviewContent />
  </ViewModelProvider>
);

export default KycManuallyInReviewPage;
